import React, { useState } from 'react';
import styled from 'styled-components';

export const TableViewSwapper = ({ onViewChange }) => {
    const [activeView, setActiveView] = useState('workload_by_stage');

    const handleViewChange = (view) => {
        setActiveView(view);
        onViewChange(view);
    };

    return (
        <SwapperContainer>
            <SwapperButton
                active={activeView === 'workload_by_stage'}
                onClick={() => handleViewChange('workload_by_stage')}
            >
                <b>По этапам</b>
            </SwapperButton>
            <Divider />
            <SwapperButton
                active={activeView === 'workload_by_month'}
                onClick={() => handleViewChange('workload_by_month')}
            >
                <b>По месяцам</b>
            </SwapperButton>
        </SwapperContainer>
    );
};

// Стилизованные компоненты
const SwapperContainer = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #949494;
  border-radius: 6px;
  overflow: hidden;
  width: fit-content;
`;

const SwapperButton = styled.button`
  padding: 8px 16px;
  border: none;
  background: ${({ active }) => (active ? '#FFFFFF' : '#f5f5f6')};
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;

  &:hover {
    background: ${({ active }) => (active ? '#FFFFFF' : '#f5f5f6')};
  }
`;

const Divider = styled.div`
  width: 1px;
  height: 20px;
  background-color: #949494;
`;
